import React, {useState} from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";

import Typography from '@material-ui/core/Typography';
import {CardElement, useStripe, useElements} from "@stripe/react-stripe-js";

import API from "@beardeddevops/react.api";
import {showBillingError, showBillingSuccess} from "utils/billingErrors";


/**
 *  @property {Accounts_Billing_Object} state
 *  @property {object} model
 *  @property {Accounts_Billing_Properties} model.properties
 *  @property {Accounts_Billing_Is} model.is
 *  @property {Accounts_Billing_Has} model.has
 */

const BillingObject = (props) => {

	const stripe = useStripe();
	const elements = useElements();
	const cardExists = props.cardExists;
	const isFflBossManaged = !!props.rootState.fflboss_pos_combo;

	const [submitting, setSubmitting] = useState(false);
	const [hovering, setHovering] = useState(false);

	const handleSubmit = async (ev) => {
		ev.preventDefault();
		if (submitting === true || !stripe || !elements) {
			return;
		}

		setSubmitting(true);

		try {
			const cardElement = elements.getElement(CardElement);

			let billingIntent = new API.BuildClass(Types.Accounts_Billing._name, API.RequestType.CREATE);
			const data = await billingIntent.submit(null, 'PUT_INTENT', true);
			if (!data?.client_secret) {
				showBillingError(API, null, 'Unable to start card setup with Stripe. Please try again or contact support.');
				setSubmitting(false);
				return;
			}

			const { setupIntent, error } = await stripe.confirmCardSetup(data.client_secret, {
				payment_method: {
					card: cardElement,
				},
			});

			if (error?.message) {
				showBillingError(API, error, error.message);
				setSubmitting(false);
				return;
			}

			let billing = new API.BuildClass(Types.Accounts_Billing._name, API.RequestType.CREATE);
			billing.object.token = setupIntent.payment_method;
			await billing.submit(null, API.RequestType.CREATE, true);
			showBillingSuccess(API, 'Card updated successfully.');
			window.location.reload();
		} catch (error) {
			showBillingError(API, error, 'Unable to update card details. Please try again or contact support.');
			setSubmitting(false);
		}
	};

	return (

		<div style={{height: "219px"}}>
			<Typography variant="h5" component="h3">
				Billing
			</Typography>
			<hr/>
			{isFflBossManaged ? (
				<div style={{
					padding: "10px",
					marginTop: "2.5rem",
					textAlign: "center",
				}}>
					<Typography component="p">
						Billing for this account is managed through FFL Boss. Please make any payment method or subscription changes there.
					</Typography>
				</div>
			) : (
				<div style={{
					padding: "10px",
					marginTop: "2.5rem",
				}}>
					<CardElement
						onReady={(element) => element}
						options={{
							iconStyle: 'solid',
							style: {
								base: {
									width: "100px",
									iconColor: '#3f51b5',
									color: 'black',
									fontSize: '16px',
									letterSpacing: "1px",
									'::placeholder': {
										color: '#aab7c4',
									},
								},
								invalid: {
									iconColor: '#ff0033',
									color: '#ff0033',
								},
							},
						}}
					/>
				<hr></hr>
				<div className={""} style={{textAlign: "right", paddingTop: "3rem"}}>
					<button
						onClick={handleSubmit}
						className={"btn primary-button mb-2 mr-2"}
						disabled={submitting}
						onMouseEnter={() => setHovering(true)}
						onMouseLeave={() => setHovering(false)}
						style={{
							background: hovering ? '#15803d' : '#16a34a',
							borderColor: hovering ? '#15803d' : '#16a34a',
							color: 'white',
							borderRadius: '6px',
						}}
					>
						{submitting ? 'Saving…' : (cardExists ? 'Update Card Number' : 'Submit Card Number')}
					</button>
				</div>
				</div>
			)}
		</div>
	)
}

export default Framework.Components.withRootState(BillingObject);
